<template>
    <div>
        <Breadcrumbs main="Settings" title="Settings" />

		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">

					<div class="card">
						<div class="card-body">
							<div class="row">
								<h5>Social Media Links</h5>
							</div><br>
							<form @submit.prevent="updateSettings('social')" enctype="multipart/form-data">
								<div class="row">
									<div class="col-sm-3">
										<div class="mb-3">
											<label class="control-label">Facebook</label>
											<input class="form-control" type="text" placeholder="" v-model="facebook" v-bind:class="{ 'is-invalid': Boolean(errors.facebook) }"/>
											<div v-for="(val, index) in errors.facebook" :key="index" class="invalid-feedback">
												<p class="mb-0">{{ val }}</p>
											</div>
										</div>
									</div>
									<div class="col-sm-3">
										<div class="mb-3">
											<label class="control-label">Twitter</label>
											<input class="form-control" type="text" placeholder="" v-model="twitter" v-bind:class="{ 'is-invalid': Boolean(errors.twitter) }"/>
											<div v-for="(val, index) in errors.twitter" :key="index" class="invalid-feedback">
												<p class="mb-0">{{ val }}</p>
											</div>
										</div>
									</div>
									<div class="col-sm-3">
										<div class="mb-3">
											<label class="control-label">Instagram</label>
											<input class="form-control" type="text" placeholder="" v-model="instagram" v-bind:class="{ 'is-invalid': Boolean(errors.instagram) }"/>
											<div v-for="(val, index) in errors.instagram" :key="index" class="invalid-feedback">
												<p class="mb-0">{{ val }}</p>
											</div>
										</div>
									</div>
									<div class="col-sm-1" style="margin-top: 30px;">
										<button type="submit" class="btn btn-primary">Update</button>
									</div>
								</div>
							</form>
						</div>
					</div>

					<div class="card">
						<div class="card-body">
							<div class="row">
								<h5>Version control</h5>
							</div><br>
							<form @submit.prevent="updateSettings('version')" enctype="multipart/form-data">
								<div class="row">
									<div class="col-sm-3">
										<div class="mb-3">
											<label class="control-label">Android</label>
											<input class="form-control" type="text" placeholder="" v-model="android_version" v-bind:class="{ 'is-invalid': Boolean(errors.android) }"/>
											<div v-for="(val, index) in errors.android" :key="index" class="invalid-feedback">
												<p class="mb-0">{{ val }}</p>
											</div>
										</div>
									</div>
									<div class="col-sm-3">
										<div class="mb-3">
											<label class="control-label">IOS</label>
											<input class="form-control" type="text" placeholder="" v-model="ios_version" v-bind:class="{ 'is-invalid': Boolean(errors.ios) }"/>
											<div v-for="(val, index) in errors.ios" :key="index" class="invalid-feedback">
												<p class="mb-0">{{ val }}</p>
											</div>
										</div>
									</div>
									
									<div class="col-sm-1" style="margin-top: 30px;">
										<button type="submit" class="btn btn-primary">Update</button>
									</div>
								</div>
							</form>
						</div>
					</div>

					<div class="card">
						<div class="card-body">
							<div class="row">
								<h5>Maintenance mode</h5>
							</div><br>
							
							<form @submit.prevent="updateSettings('maintenance')" enctype="multipart/form-data">
								<div class="row">
									<div class="col-sm-3">
										<div class="mb-3">
											<label class="control-label">Maintenance</label>
											<select v-model="maintenance" class="form-control" v-bind:class="{ 'is-invalid': Boolean(errors.maintenance) }">
												<option value="0">No</option>
												<option value="1">Yes</option>
											</select>
											<div v-for="(val, index) in errors.maintenance" :key="index" class="invalid-feedback">
												<p class="mb-0">{{ val }}</p>
											</div>
										</div>
									</div>
									<div class="col-sm-5">
										<div class="mb-3">
											<label class="control-label">Reason for maintenance</label>
											<input class="form-control" type="text" placeholder="" v-model="maintenance_reason" v-bind:class="{ 'is-invalid': Boolean(errors.reason) }"/>
											<div v-for="(val, index) in errors.reason" :key="index" class="invalid-feedback">
												<p class="mb-0">{{ val }}</p>
											</div>
										</div>
									</div>
									
									<div class="col-sm-1" style="margin-top: 30px;">
										<button type="submit" class="btn btn-primary">Update</button>
									</div>
								</div>
							</form>
						</div>
					</div>

					<div class="card">
						<div class="card-body">
							<div class="row">
								<h5>Admin details</h5>
							</div><br>
							
							<form @submit.prevent="updateSettings('admin')" enctype="multipart/form-data">
								<div class="row">
									<div class="col-sm-3">
										<div class="mb-3">
											<label class="control-label">Name</label>
											<input class="form-control" type="text" placeholder="" v-model="name" v-bind:class="{ 'is-invalid': Boolean(errors.name) }"/>
											<div v-for="(val, index) in errors.name" :key="index" class="invalid-feedback">
												<p class="mb-0">{{ val }}</p>
											</div>
										</div>
									</div>
									<div class="col-sm-3">
										<div class="mb-3">
											<label class="control-label">Email</label>
											<input class="form-control" type="text" placeholder="" v-model="email" v-bind:class="{ 'is-invalid': Boolean(errors.email) }"/>
											<div v-for="(val, index) in errors.email" :key="index" class="invalid-feedback">
												<p class="mb-0">{{ val }}</p>
											</div>
										</div>
									</div>
									
									<div class="col-sm-1" style="margin-top: 30px;">
										<button type="submit" class="btn btn-primary">Update</button>
									</div>
								</div>
							</form>
						</div>
					</div>

					<div class="card">
						<div class="card-body">
							<div class="row">
								<h5>Change password</h5>
							</div><br>
							
							<form @submit.prevent="updateSettings('password')">
								<div class="row">
									<div class="col-sm-4">
										<div class="mb-3">
											<label class="control-label">Password</label>
											<input class="form-control" type="password" placeholder="" v-model="password" v-bind:class="{ 'is-invalid': Boolean(errors.password) }"/>
											<div v-for="(val, index) in errors.password" :key="index" class="invalid-feedback">
												<p class="mb-0">{{ val }}</p>
											</div>
										</div>
									</div>
									<div class="col-sm-4">
										<div class="mb-3">
											<label class="control-label">Confirm Password</label>														
											<input class="form-control" type="Password" placeholder="" v-model="confirm_password" v-bind:class="{ 'is-invalid': Boolean(errors.password_confirmation) }"/>
											<div v-for="(val, index) in errors.password_confirmation" :key="index" class="invalid-feedback">
												<p class="mb-0">{{ val }}</p>
											</div>
										</div>
									</div>
									
									<div class="col-sm-1" style="margin-top: 30px;">
										<button type="submit" class="btn btn-primary">Update</button>
									</div>
								</div>
							</form>
						</div>
					</div>

					<div class="card">
						<div class="card-body">
							<div class="row">
								<h5>Ads Approval</h5>
							</div><br>

							<form @submit.prevent="updateSettings('auto_approval')">
								<div class="row">
									<div class="col-sm-3">
										<div class="mb-3">
											<label class="control-label">Auto Approval</label>
											<select v-model="auto_approval" class="form-control" v-bind:class="{ 'is-invalid': Boolean(errors.auto_approval) }">
												<option value="0">No</option>
												<option value="1">Yes</option>
											</select>
											<div v-for="(val, index) in errors.auto_approval" :key="index" class="invalid-feedback">
												<p class="mb-0">{{ val }}</p>
											</div>
										</div>
									</div>
									
									<div class="col-sm-1" style="margin-top: 30px;">
										<button type="submit" class="btn btn-primary">Update</button>
									</div>
								</div>
							</form>
						</div>
					</div>

				</div>
			</div>
		</div>


		
	</div>
</template>

<script>
	export default {
		name: "SettingsPage",
		data() {
			return {
				android_version: null,
				ios_version: null,
				facebook: "",
				twitter: "",
				instagram: "",
				name: "",
				email: "",
				maintenance: null,
				maintenance_reason: "",
				password: "",
				confirm_password: "",
				auto_approval: null,
				token: "",
				errors: {},
			};
		},

		created() {
			this.fetchSettings();
		},

		methods: {
			fetchSettings(page_url = null) {
				this.getToken();
				let url = "/api/admin/settings";
				page_url = page_url || url;
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;

						this.android_version = responseData.android_version;
						this.ios_version = responseData.ios_version;
						this.facebook = responseData.facebook;
						this.twitter = responseData.twitter;
						this.instagram = responseData.instagram;
						this.name = responseData.admin_name;
						this.email = responseData.admin_email;
						this.maintenance = responseData.maintenance;
						this.maintenance_reason = responseData.maintenance_reason;
						this.auto_approval = responseData.auto_approval;

						console.log(responseData);
					})
					.catch((err) => console.log(err));
			},

			getToken() {
                if (localStorage.getItem('slo_admin')) {
                    var slo_admin =  JSON.parse(localStorage.getItem('slo_admin')); 
                    
                    if(slo_admin.token) {

                        this.token = slo_admin.token;
                        this.user = slo_admin;

                    } else {
                        this.$swal("", "Failed to fetch token, please login again", "error");
                        this.$router.push({ name: "Login" });
                    }

                } else {
                    this.$swal("", "Session expired, please login again", "error");
                    this.$router.push({ name: "Login" });
                }
            },
			updateSettings(param) {
				this.getToken();
				let formData = new FormData();
				let url = "";
				if (param == "social") {
					formData.append("facebook", this.facebook);
					formData.append("twitter", this.twitter);
					formData.append("instagram", this.instagram);

					url = "/api/admin/settings/update_media";
				} else if (param == "version") {
					formData.append("android", this.android_version);
					formData.append("ios", this.ios_version);

					url = "/api/admin/settings/update_version";
				} else if (param == "maintenance") {
					formData.append("maintenance", this.maintenance);
					formData.append("reason", this.maintenance_reason);

					url = "/api/admin/settings/update_maintenance";
				} else if (param == "admin") {
					formData.append("name", this.name);
					formData.append("email", this.email);

					url = "/api/admin/settings/update_username";
				} else if (param == "password") {
					formData.append("password", this.password);
					formData.append("password_confirmation", this.confirm_password);

					url = "/api/admin/settings/update_password";
				} else if (param == "auto_approval") {
					formData.append("status", this.auto_approval);
					url = "/api/admin/settings/update_approval_mode";
				}

				const config = {
					headers: {
						Authorization: "Bearer " + this.token,
					},
				};

				this.$axios
					.post(url, formData, config)
					.then((response) => {
						if (response.data.status) {
							this.$swal("", response.data.message, "success");
						} else {
							this.$swal("", response.data.message, "error");
						}
						this.fetchSettings();
						this.clearForm();
						if (param == "password") {
							this.password = "";
							this.confirm_password = "";
						}
					})
					.catch((error) => {
						if (error.response) {
							if (error.response.data.message) {
								this.errors = error.response.data.message;
								this.$swal("", error.response.data.message, "error");
							} else {
								this.$swal("", "Something went wrong", "error");
							}
						} else {
							this.$swal("", "Something went wrong", "error");
						}
					});
			},
			clearForm() {
				this.errors = {};
			},
		},
	};
</script>